export abstract class IAppDataStore {
    abstract get(key: string): any;
    abstract put(key: string, value: any);
    abstract clearAll();
}
